// src/layouts/DashboardLayout.jsx
import React from 'react';
import DashboardSidebar from '../components/DashboardSidebar';

const DashboardLayout = ({ children }) => {
    return (
        <div className="dashboard-root">
            <DashboardSidebar />
            <main className="dashboard-content">
                {children}
            </main>
        </div>
    );
};

export default DashboardLayout;